defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/LoadingRing',
    'DanskeSpil/Domain/NumberGames/Scripts/Components/Shared/Svg/Svg',
  ],
  function (m, Ensighten, LoadingRing, Svg) {
    // Context:
    var CtaButton = function ({ disabled, loading, options, className, onClick, href, text, icon, disableTracking = false, }) {
      var buttonOptions = {
        class: 'play-together-button'
      };
      var ctaElement = 'div';

      if (className) {
        buttonOptions.class += ' ' + className;
      }

      if (disabled) {
        buttonOptions.class = (buttonOptions.class || '') + ' disabled';
      }

      if (options) {
        options.forEach((option) => {
          buttonOptions.class += ' ' + option;
        });
      }

      const addTrackingEvent = () => {
        if (disableTracking || typeof text !== 'string') return;
        Ensighten.pushGaEventOnPageRedirect('spil_sammen', 'cta_click', text.toLowerCase());
      };

      buttonOptions.onclick = (event) => {
        addTrackingEvent();

        if (onClick) {
          event.preventDefault();
          event.stopPropagation();

          if (disabled || loading) {
            return;
          }

          return onClick(event);
        }
      };

      if (href && !disabled) {
        ctaElement = 'a';
        buttonOptions.href = href;

        if (Array.isArray(options) && options.includes('club-color-on-active-page')) {
          const pathBeforeQuery = href.split('?')[0].replace(window.location.origin, '');
          if (window.location.pathname === pathBeforeQuery) {

            if (!buttonOptions.class.includes(' club-color-on-active-page--active')) {
              buttonOptions.class += ' club-color-on-active-page--active';
            }
          }
        }
      }

      var _icon = function () {
        if (loading) {
          return LoadingRing();
        }

        if (icon) {
          return m(Svg, { classNames: 'play-together-button__icon', src: '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#' + icon });
        }

        return null;
      };

      // Return:
      return m(ctaElement, buttonOptions, [
        _icon(),
        m('span', text) || null
      ]);
    };

    // Public functions:
    return CtaButton;
  });
